import { IActivityHistoryUpFilter } from "../../model";

export class AddUpFiltersCommand {
  constructor(public payload: IActivityHistoryUpFilter) {}
}
